import React, { Fragment } from "react";

const RowActions = ({
  isEditing,
  isEditDisabled,
  isSaving,
  onEdit,
  onConfirm,
  onCancel,
  onDelete,
  showDelete = false,
}) => {
  if (isEditing) {
    return (
      <Fragment>
        <button
          type="button"
          title="Confirm"
          className="base-button icon-button btn-success"
          onClick={onConfirm}
          disabled={isSaving}
        >
          <span className="material-icons">check_circle</span>
        </button>
        <button
          type="button"
          title="Cancel"
          className="base-button icon-button btn-danger ml-2"
          onClick={onCancel}
          disabled={isSaving}
        >
          <span className="material-icons">cancel</span>
        </button>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <button
        type="button"
        title="Edit"
        className="base-button icon-button evo-blue"
        onClick={onEdit}
        disabled={isEditDisabled || isSaving}
      >
        <span className="material-icons">edit</span>
      </button>
      {showDelete && (
        <button
          type="button"
          title="Delete"
          className="base-button icon-button btn-danger ml-2"
          onClick={onDelete}
          disabled={isEditDisabled || isSaving}
        >
          <span className="material-icons">delete</span>
        </button>
      )}
    </Fragment>
  );
};

export default RowActions;
